import type { ChessBoard, ChessPosition, ChessColor } from '../../types/chess';

export function getInitialBoard(): ChessBoard {
  const board: ChessBoard = Array(8).fill(null).map(() => Array(8).fill(null));
  
  // Set up pawns
  for (let col = 0; col < 8; col++) {
    board[1][col] = { type: 'pawn', color: 'black' };
    board[6][col] = { type: 'pawn', color: 'white' };
  }

  // Set up other pieces
  const backRow: Array<ChessPiece['type']> = [
    'rook', 'knight', 'bishop', 'queen', 'king', 'bishop', 'knight', 'rook'
  ];
  backRow.forEach((type, col) => {
    board[0][col] = { type, color: 'black' };
    board[7][col] = { type, color: 'white' };
  });

  return board;
}

export function makeMove(board: ChessBoard, from: ChessPosition, to: ChessPosition): ChessBoard {
  const newBoard = board.map(row => [...row]);
  newBoard[to.row][to.col] = newBoard[from.row][from.col];
  newBoard[from.row][from.col] = null;
  return newBoard;
}

export function findKing(board: ChessBoard, color: ChessColor): ChessPosition | null {
  for (let row = 0; row < 8; row++) {
    for (let col = 0; col < 8; col++) {
      const piece = board[row][col];
      if (piece?.type === 'king' && piece.color === color) {
        return { row, col };
      }
    }
  }
  return null;
}

export function isValidPosition(row: number, col: number): boolean {
  return row >= 0 && row < 8 && col >= 0 && col < 8;
}